<script setup>
import RatingSquareScore from '@/Pages/DomainScore/Partials/RatingSquareScore.vue';
import RiskLabel from '@/Pages/DomainScore/Partials/RiskLabel.vue';
import { inject } from 'vue';
import BimiCard from '@/Pages/DomainScore/Partials/DetailedReport/Branding/BimiCard.vue';
import ACTION_TYPES, {
  getActionTypeFromScore
} from '@/Common/Enum/ActionType.js';
import Help from '@/Components/Help.vue';

const result = inject('score');
const actionType = getActionTypeFromScore(result.marketing.score);
</script>

<template>
  <div>
    <div class="flex items-start gap-3">
      <div class="flex flex-col items-center">
        <RatingSquareScore :score="result.marketing.score" />
        <RiskLabel
          :score="result.marketing.score"
          class="mt-1 text-sm text-nowrap"
        />
      </div>
      <div class="flex flex-col gap-2">
        <h5 class="flex items-center gap-2 text-lg font-bold text-white">
          {{
            $t(
              'domain_score.partials.detailed_report.branding.branding_detailed_card.branding_rating'
            )
          }}
          <Help
            :text="
              $t(
                'domain_score.partials.detailed_report.branding.branding_detailed_card.your_branding_rating'
              )
            "
          />
        </h5>
        <p v-if="actionType === ACTION_TYPES.NO_ACTION">
          {{
            $t(
              'domain_score.partials.detailed_report.branding.branding_detailed_card.your_org_uses'
            )
          }}
        </p>
        <p v-else-if="actionType === ACTION_TYPES.ACTION_RECOMMENDED">
          {{
            $t(
              'domain_score.partials.detailed_report.branding.branding_detailed_card.your_email_branding_settings'
            )
          }}
        </p>
        <p v-else>
          {{
            $t(
              'domain_score.partials.detailed_report.branding.branding_detailed_card.right_now_your'
            )
          }}
        </p>
      </div>
    </div>
    <BimiCard />
  </div>
</template>
